import React from 'react'
import AboutUs from '../about-us'

const AboutUsDe = () => {
    return <AboutUs languageCode="de" />
}

export default AboutUsDe
